import React, { useMemo } from "react";
import { disableEntitySelection } from "utils/builder";
import { useAppEntities, useGroupedAppEntities } from "utils/selectors";
import BlockOption from "components/FormerEditor/BlockOption";
import { schemaPropertiesToValues } from "../common";
import { v4 as uuidv4 } from "uuid";
import { ENTITY_TYPE } from "../common/constants/entity";
import Tabs from "components/Tabs";
import { useManifestFormFields } from "utils/hooks/manifest";
import { useUserFeature } from "utils/hooks/capabilities";
import { USER_CAPABILITY } from "utils/constants/capability";
import { RESTRICTED_FIELDS } from "utils/constants/manifest";
import { BLOCK_SETTINGS_TABS_PROPS } from "components/Tabs";
import {
  COMBINATION_FIELDS,
  ENTITY_TYPE_LABEL_MAP
} from "utils/constants/form";

const FieldOptionsList = ({ entities, onClick }) => {
  const formFields = useManifestFormFields();

  const options = entities.map((entity, entityIx) => {
    const canSelect = !disableEntitySelection(entity, formFields);
    const schemaValues = schemaPropertiesToValues(entity.schema.properties);

    const scaffoldedField = {
      uuid: uuidv4(),
      uid: entity.uid,
      ...schemaValues
    };

    const block = (
      <BlockOption
        canSelect={canSelect}
        key={entityIx}
        {...entity}
        pill={COMBINATION_FIELDS[entity.uid] && "Combo"}
        onClick={() => {
          onClick(scaffoldedField);
        }}
      />
    );

    return (
      <li key={entityIx} className="w-100">
        {block}
      </li>
    );
  });

  return <ul className="ma0 pa0 list bg-white bh--inset">{options}</ul>;
};

const FieldPicker = ({ name, onClick }) => {
  const { primitives, specialized } = useGroupedAppEntities();

  const tabProps = {
    ...BLOCK_SETTINGS_TABS_PROPS,
    tabs: [
      {
        name: ENTITY_TYPE_LABEL_MAP[ENTITY_TYPE.PRIMITIVE],
        id: ENTITY_TYPE.PRIMITIVE,
        node: (
          <FieldOptionsList
            name={name}
            onClick={onClick}
            entities={primitives}
          />
        )
      },
      {
        name: ENTITY_TYPE_LABEL_MAP[ENTITY_TYPE.SPECIALIZED],
        id: ENTITY_TYPE.SPECIALIZED,
        node: (
          <FieldOptionsList
            name={name}
            onClick={onClick}
            entities={specialized}
          />
        )
      }
    ]
  };

  return (
    <div className="pt3">
      <Tabs {...tabProps} />
    </div>
  );
};

export default FieldPicker;
